import React, { useState, useEffect, useRef } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import './QuoteForm.css'
import { getCurrentPage } from '../../pages/WorkDetail/work_utils'
import * as CONST from '../../script/const'
import WorkDetailHeader from '../WorkDetail/WorkDetailHeader'
import MultiDatePicker from '../../components/MultiDatePicker/MultiDatePicker'
import axios from 'axios'
import { getAPIUrl } from '../../script/util'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const QuoteForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobileNo: '',
    eventDates: [],
    otherEventName: '',
    cityVenue: '',
    budgetBracket: ''
  })

  const currentPage = getCurrentPage(CONST, CONST.QUOTE_FORM);
  const [dialCode, setDialCode] = useState('91')
  const [localNumber, setLocalNumber] = useState('')
  const [recaptchaToken, setRecaptchaToken] = useState(null)
  const [successMessage, setSuccessMessage] = useState(null)
  const recaptchaContainerRef = useRef(null)
  const expirationTimer = useRef(null)
  const formRef = useRef(null)
  const recaptchaTokenRef = useRef(null)
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  

  useEffect(() => {
    if (recaptchaToken) {
      if (expirationTimer.current) {
        clearTimeout(expirationTimer.current)
      }
      
      expirationTimer.current = setTimeout(() => {
        recaptchaTokenRef.current = null
        setRecaptchaToken(null)
        if (window.grecaptcha && recaptchaContainerRef.current) {
          try {
            const widgetId = recaptchaContainerRef.current.getAttribute('data-widget-id')
            if (widgetId) {
              window.grecaptcha.reset(widgetId)
            } else {
              const widget = recaptchaContainerRef.current.querySelector('.g-recaptcha')
              if (widget) {
                const widgetIdAttr = widget.getAttribute('data-widget-id')
                if (widgetIdAttr) {
                  window.grecaptcha.reset(parseInt(widgetIdAttr))
                }
              }
            }
          } catch (error) {
            console.error('Error resetting reCAPTCHA:', error)
          }
        }
      }, 120000)
    }

    return () => {
      if (expirationTimer.current) {
        clearTimeout(expirationTimer.current)
      }
    }
  }, [recaptchaToken])

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://www.google.com/recaptcha/api.js'
    script.async = true
    script.defer = true
    document.body.appendChild(script)

    window.reCaptchaCallbck = (token) => {
      recaptchaTokenRef.current = token // Store immediately in ref for synchronous access
      setRecaptchaToken(token)
      // Programmatically submit the form when captcha succeeds
      if (formRef.current) {
        if (typeof formRef.current.requestSubmit === 'function') {
          formRef.current.requestSubmit()
        } else {
          formRef.current.dispatchEvent(
            new Event('submit', { bubbles: true, cancelable: true })
          )
        }
      }
    }

    window.reCaptchaExpired = () => {
      recaptchaTokenRef.current = null
      setRecaptchaToken(null)
    }

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script)
      }
      delete window.reCaptchaCallbck
      delete window.reCaptchaExpired
      if (expirationTimer.current) {
        clearTimeout(expirationTimer.current)
      }
    }
  }, [])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleDateChange = (dates) => {
    // Keep internal format (YYYY-MM-DD) for the calendar
    setFormData(prev => ({
      ...prev,
      eventDates: dates
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const tokenToUse = recaptchaTokenRef.current || recaptchaToken

    if (!formData.name.trim()) {
      alert('Please enter your name')
      return
    }
    if (!localNumber) {
      alert('Please enter your mobile number')
      return
    }
    if (!formData.otherEventName.trim()) {
      alert('Please enter the event name')
      return
    }
    if (!formData.budgetBracket) {
      alert('Please select a budget bracket')
      return
    }
    if (!tokenToUse) {
      alert('Please complete the reCAPTCHA verification')
      return
    }

    const fullNumber = formData.mobileNo.startsWith('+')
      ? formData.mobileNo
      : `+${formData.mobileNo}`

    const normalizedEvents = formData.otherEventName.trim()
      ? [formData.otherEventName.trim()]
      : []

    const formattedEventDates = Array.isArray(formData.eventDates)
      ? formData.eventDates.map(dateStr => {
          const [year, month, day] = dateStr.split('-')
          return `${day}-${month}-${year}` // DD-MM-YYYY
        })
      : []
    const submitData = {
      name: formData.name,
      number: fullNumber,
      eventDates: formattedEventDates,
      events: normalizedEvents,
      location: formData.cityVenue,
      budget: formData.budgetBracket,
      captcha_token: tokenToUse,
      id: id
    }

    try {
        const res = await axios.post(getAPIUrl(`/api/crm/react/leadform/`), submitData, {
            headers: {},
            data: submitData,
        });
        if(res.data.success) {
          const message = res.data.message || res.data.success || 'Your request has been recorded successfully! We will get back to you soon.'
          setSuccessMessage(message)
          // Reset form after success
          setFormData({
            name: '',
            mobileNo: '',
            eventDates: [],
            otherEventName: '',
            cityVenue: '',
            budgetBracket: ''
          })
          setLocalNumber('')
          setDialCode('91')
          recaptchaTokenRef.current = null
          setRecaptchaToken(null)
        }
    } catch (error) {
        console.log('Error:', error);
        alert('Something went wrong. Please try again.')
    }
  }

  const isFormReadyForCaptcha = Boolean(
    formData.name.trim() &&
    localNumber &&
    formData.budgetBracket &&
    formData.otherEventName.trim()
  )

  return (
    <div className="quote-form-container">
      <Navbar location={""} title={`quoteForm`}/>
      <WorkDetailHeader currentPage={currentPage} title={`Get a Quote | EventGraphia`}/>
      {successMessage && (
        <div className="success-overlay" onClick={() => setSuccessMessage(null)}>
          <div className="success-modal" onClick={(e) => e.stopPropagation()}>
            <div className="success-icon">✓</div>
            <h2 className="success-title">Request Submitted Successfully!</h2>
            <p className="success-message">{successMessage}</p>
            <button 
              className="success-close-btn"
              onClick={() => setSuccessMessage(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}
      <div className="quote-form-wrapper">
        <form
          className="quote-form"
          onSubmit={handleSubmit}
          ref={formRef}
        >
          
          <div className="form-el">
            <label htmlFor="name">Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              placeholder="Enter your name"
            />
          </div>

          <div className="form-el">
            <label htmlFor="mobileNo">Mobile No *</label>
            <div className="phone-input-row">
              <PhoneInput
                country="in"
                preferredCountries={['in', 'us', 'gb', 'ae', 'sg', 'ca', 'de', 'fr']}
                value={`+${dialCode}`}
                onChange={(_, countryData) => {
                  const newDial = countryData?.dialCode || dialCode
                  setDialCode(newDial)
                  setFormData(prev => ({
                    ...prev,
                    mobileNo: `+${newDial}${localNumber}`
                  }))
                }}
                containerClass="phone-country-container"
                inputClass="phone-country-input"
                inputProps={{
                  name: 'mobileNoCountry',
                  id: 'mobileNoCountry',
                  readOnly: true,
                }}
              />
              <input
                type="tel"
                id="mobileNo"
                name="mobileNo"
                className="phone-number-input"
                value={localNumber}
                onChange={(e) => {
                  const onlyDigits = e.target.value.replace(/\D/g, '')
                  setLocalNumber(onlyDigits)
                  setFormData(prev => ({
                    ...prev,
                    mobileNo: `+${dialCode}${onlyDigits}`
                  }))
                }}
                required
                placeholder="Enter mobile number"
              />
            </div>
          </div>

          <div className="form-el">
            <label htmlFor="eventDates">Event Dates</label>
            <MultiDatePicker
              selectedDates={formData.eventDates}
              onChange={handleDateChange}
              placeholder="Click to select dates"
            />
          </div>

          <div className="form-el">
            <label htmlFor="otherEventName">Events *</label>
            <input
              type="text"
              id="otherEventName"
              name="otherEventName"
              value={formData.otherEventName}
              onChange={handleInputChange}
              required
              placeholder="Enter event name"
            />
          </div>

          <div className="form-el">
            <label htmlFor="cityVenue">Venue & City</label>
            <input
              type="text"
              id="cityVenue"
              name="cityVenue"
              value={formData.cityVenue}
              onChange={handleInputChange}
              placeholder="Enter venue and city"
            />
          </div>

          <div className="form-el">
            <label htmlFor="budgetBracket">Budget Bracket *</label>
            <select
              id="budgetBracket"
              name="budgetBracket"
              value={formData.budgetBracket}
              onChange={handleInputChange}
              required
            >
              <option value="">Select budget bracket</option>
              <option value="1.5-2 Lakhs">1.5-2 Lakhs</option>
              <option value="2-2.5 Lakhs">2-2.5 Lakhs</option>
              <option value="2.5-3 Lakhs">2.5-3 Lakhs</option>
              <option value="3+ Lakhs">3+ Lakhs</option>
            </select>
          </div>

          <div className="form-el">
            <div className="qr-show">
              <div className="captcha">
                <div
                  className="g-recaptcha"
                  data-callback="reCaptchaCallbck"
                  data-expired-callback="reCaptchaExpired"
                  data-sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
                  style={{
                    transform: 'scale(0.93)',
                    WebkitTransform: 'scale(0.93)',
                    transformOrigin: '0 0',
                    WebkitTransformOrigin: '0 0',
                    display: isFormReadyForCaptcha ? 'block' : 'none',
                  }}
                ></div>
              </div>
            </div>
          </div>

          <div className="form-el" style={{ visibility: 'hidden', marginBottom: 0, height: 0 }}>
            <button 
              type="submit" 
              className="submit-btn"
              disabled={!recaptchaToken}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default QuoteForm